import React from 'react';
import {  Stack, Typography } from '@mui/material';
import { SunTapVerifiedIcon } from "./Icons";

interface VerifiedBadgeProps {
    sx?: object;
    isBot?: boolean;
}

const VerifiedBadge: React.FC<VerifiedBadgeProps> = ({ sx, isBot = false }) => {
    return (
        <Stack
            direction="row"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                ...sx,
            }}
        >
            <SunTapVerifiedIcon sx={{ fontSize: '26px', mr: 1 }}/>
            <Typography 
                variant="body2" 
                sx={{ 
                    color: '#4CAF50', 
                    fontWeight: 500,
                    fontSize: '0.85rem'
                }}
            >
                {isBot 
                    ? "This pub has been suntap verified. This means that the garden geometry has been confirmed to be correct by our moderators."
                    : ""
                }
            </Typography>
        </Stack>
    );
};

export default VerifiedBadge; 